'use client'

import CreationToolCutOutMode from 'creation/src/creation-tools/types/cut-out-mode'
import Navigation from '../../navigation'
import { useCutOut } from './cut-out-context'

// Legacy `UtilityButton` (components/buttons.ts:65-95) — used only here, so it
// becomes a class string rather than a new shared primitive. `rounded-[2px]`
// is BORDER_RADIUS_SMALL, `active:opacity-80` is BUTTON_ACTIVE_OPACITY, both
// from packages/creation/src/creation-tools/constants.ts. `ml-[10px]` and
// `animate-ct-pop-in` come from the wrapper at navigation.tsx:9-12.
const buttonClassName =
    'ml-[10px] h-[36px] leading-[36px] px-[12px] bg-black text-white text-[15px] font-bold text-center antialiased rounded-[2px] cursor-pointer select-none active:opacity-80 animate-ct-pop-in'

// Legacy's `i` rules inside `UtilityButton` (buttons.ts:78-92). The `<i>` is
// simultaneously :first-child and :last-child (a trailing text node doesn't
// count for :last-child), so both margin rules fire — keep both. 38px is
// legacy's own value, 2px taller than the button's 36px height.
const iconClassName = 'inline-block text-[16px] font-normal leading-[38px] align-middle mr-[6px] ml-[6px]'

// Port of cut-out/navigation.tsx:14-41.
const CutOutNavigation = () => {
    const { mode, undoStepCount, setUndoStepCount, isResetEnable, resetCanvas } = useCutOut()

    const onUndoClick = () => {
        // Redundant given the visibility gate below, but legacy keeps this
        // guard (navigation.tsx:17-21) — kept to avoid an unrecorded change.
        if (mode === CreationToolCutOutMode.Lasso) {
            setUndoStepCount(undoStepCount - 1)
        }
    }

    const onResetClick = () => {
        resetCanvas()
    }

    return (
        <Navigation>
            {mode === CreationToolCutOutMode.Lasso && undoStepCount > 0 && (
                <div data-testid="undo" onClick={onUndoClick} className={buttonClassName}>
                    <i className={`ss-replay ${iconClassName}`} /> Undo
                </div>
            )}
            {isResetEnable && (
                <div data-testid="reset" onClick={onResetClick} className={buttonClassName}>
                    <i className={`ss-delete ${iconClassName}`} /> Reset
                </div>
            )}
        </Navigation>
    )
}

export default CutOutNavigation
